export const ReferenceNote = ({ reference, testId, className = "" }) => {
  if (!reference) return null;
  return (
    <p
      data-testid={testId}
      className={`pt-5 border-t border-[#E2DEDA] text-[13px] text-[#666A70] leading-relaxed ${className}`}
    >
      Référence de votre demande :{" "}
      <span className="font-mono text-[#181A1D] tracking-[0.08em]">{reference}</span>
      <br />
      Conservez-la pour tout échange ultérieur.
    </p>
  );
};
